module.exports = __webpack_public_path__ + "static/media/integral.b7b9639b.svg";